// Lazy-load KaTeX and render any math placeholders left by markdown.ts.
let katexPromise: Promise<typeof import("katex")> | null = null;

async function loadKatex() {
  if (!katexPromise) {
    katexPromise = (async () => {
      // Inject the CSS once.
      if (!document.querySelector('link[data-katex]')) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.dataset.katex = "1";
        // CSS bundled with KaTeX package; Vite copies it via JS import side-effects.
        await import("katex/dist/katex.min.css");
      }
      return import("katex");
    })();
  }
  return katexPromise;
}

export async function renderMathIn(root: HTMLElement): Promise<void> {
  const targets = root.querySelectorAll<HTMLElement>(".math-inline, .math-display");
  if (targets.length === 0) return;
  const katex = (await loadKatex()).default;
  for (const el of Array.from(targets)) {
    const tex = el.dataset.tex ?? "";
    const display = el.classList.contains("math-display");
    try {
      katex.render(tex, el, { displayMode: display, throwOnError: false, output: "html" });
    } catch (err) {
      el.textContent = `[math error] ${(err as Error).message}`;
    }
  }
}
